import React, {useState} from 'react';
import {StepsTypeV2} from "../WorkflowEditorV2";
import {WorkflowAppSelectorV2} from "./WorkflowAppSelectorV2";
import {WorkflowAccountSelectV2} from "./WorkflowAccountSelectV2";
import {WorkflowEditorTriggerDTO} from "../../../api/workflow/WorkflowDTO";
import {WorkflowStepsV2} from "./WorkflowStepsV2";
import {WorkflowTriggerTestV2} from "./WorkflowTriggerTestV2";

interface Props {
    readonly data: WorkflowEditorTriggerDTO
    readonly setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
    readonly stepInfo: any
    readonly onSetStepInfo: (info: any) => void
}

export function WorkflowTriggerStepsWrapper({data,setFieldValue,onSetStepInfo,stepInfo}: Props) {

    const steps = [
        {
            label: StepsTypeV2.ChooseAppEndEvent,
            id: 1,
            done: Boolean(data.appId) && Boolean(data.eventId),
            hide: false,
            component: WorkflowAppSelectorV2,
            fieldName: ["appId", "eventId"]
        },
        {
            label: StepsTypeV2.ChooseAccount,
            id: 2,
            done: Boolean(data.accountId),
            hide: Boolean(data.appId === 10019),
            component: WorkflowAccountSelectV2,
            fieldName: "accountId"
        },
        // Todo | Trigger Setup
        {
            label: StepsTypeV2.TestTrigger,
            id: 3,
            done: data?.inputData ? Boolean(Object.keys(data.inputData).length) : false,
            hide: Boolean(data.appId === 10019),
            component: WorkflowTriggerTestV2,
        },
    ];

    return (
        <WorkflowStepsV2
            isTrigger={true}
            onSetStepInfo={onSetStepInfo}
            stepInfo={stepInfo}
            steps={steps}
            data={data}
            setFieldValue={setFieldValue}
        />
    );
}

